import { render, staticRenderFns } from "./CartTable.vue?vue&type=template&id=04824601&scoped=true&"
import script from "./CartTable.vue?vue&type=script&lang=js&"
export * from "./CartTable.vue?vue&type=script&lang=js&"
import style0 from "./CartTable.vue?vue&type=style&index=0&id=04824601&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04824601",
  null
  
)

export default component.exports